module.exports = __webpack_public_path__ + "static/media/icons_main.25b69766.svg";